import IUniswapV2Router02Json from '@uniswap/v2-periphery/build/IUniswapV2Router02.json';
import SwapRouterJSON from '@uniswap/v3-periphery/artifacts/contracts/SwapRouter.sol/SwapRouter.json';
import EIP_2612 from '../abis/eip_2612.json';
import ERC20_ABI from '../abis/erc20.json';
import { V2_ROUTER_ADDRESS, V3_ROUTER_ADDRESS } from '../constants/addresses';
import { getContract } from '../utils';
var IUniswapV2Router02ABI = IUniswapV2Router02Json.abi;
var IUniswapV3RouterABI = SwapRouterJSON.abi;
// returns null on errors
export function getUniswapContract(library, account, chainId, addressOrAddressMap, ABI, withSignerIfPossible) {
    if (withSignerIfPossible === void 0) { withSignerIfPossible = true; }
    return function () {
        if (!addressOrAddressMap || !ABI || !library || !chainId)
            return null;
        var address;
        if (typeof addressOrAddressMap === 'string')
            address = addressOrAddressMap;
        else
            address = addressOrAddressMap[chainId];
        if (!address)
            return null;
        try {
            return getContract(address, ABI, library, withSignerIfPossible && account ? account : undefined);
        }
        catch (error) {
            console.error('Failed to get contract', error);
            return null;
        }
    };
}
export function getTokenContract(library, account, chainId, tokenAddress, withSignerIfPossible) {
    return getUniswapContract(library, account, chainId, tokenAddress, ERC20_ABI, withSignerIfPossible);
}
// export function getERC721Contract(nftAddress?: string) {
//   return getContract<Erc721>(nftAddress, ERC721_ABI, false)
// }
// export function getERC1155Contract(nftAddress?: string) {
//   return getContract<Erc1155>(nftAddress, ERC1155_ABI, false)
// }
// export function getArgentWalletDetectorContract() {
//   return getContract<ArgentWalletDetector>(ARGENT_WALLET_DETECTOR_ADDRESS, ARGENT_WALLET_DETECTOR_ABI, false)
// }
// export function getENSRegistrarContract(withSignerIfPossible?: boolean) {
//   return getContract<EnsRegistrar>(ENS_REGISTRAR_ADDRESSES, ENS_ABI, withSignerIfPossible)
// }
// export function getENSResolverContract(address: string | undefined, withSignerIfPossible?: boolean) {
//   return getContract<EnsPublicResolver>(address, ENS_PUBLIC_RESOLVER_ABI, withSignerIfPossible)
// }
// export function getBytes32TokenContract(tokenAddress?: string, withSignerIfPossible?: boolean): Contract | null {
//   return getContract(tokenAddress, ERC20_BYTES32_ABI, withSignerIfPossible)
// }
export function getEIP2612Contract(library, account, chainId, tokenAddress) {
    return getUniswapContract(library, account, chainId, tokenAddress, EIP_2612, false)();
}
// export function getPairContract(pairAddress?: string, withSignerIfPossible?: boolean): Contract | null {
//   return getContract(pairAddress, IUniswapV2PairABI, withSignerIfPossible)
// }
export function getV2RouterContract(library, account, chainId) {
    return getUniswapContract(library, account, chainId, V2_ROUTER_ADDRESS, IUniswapV2Router02ABI, true)();
}
export function getV3RouterContract(library, account, chainId) {
    return getUniswapContract(library, account, chainId, V3_ROUTER_ADDRESS, IUniswapV3RouterABI, true)();
}
// export function getInterfaceMulticall() {
//   return getContract<UniswapInterfaceMulticall>(MULTICALL_ADDRESS, MulticallABI, false) as UniswapInterfaceMulticall
// }
// export function getV3NFTPositionManagerContract(withSignerIfPossible?: boolean): NonfungiblePositionManager | null {
//   return getContract<NonfungiblePositionManager>(
//     NONFUNGIBLE_POSITION_MANAGER_ADDRESSES,
//     NFTPositionManagerABI,
//     withSignerIfPossible
//   )
// }
// export function getTickLens(): TickLens | null {
//   const { chainId } = getActiveWeb3React()
//   const address = chainId ? TICK_LENS_ADDRESSES[chainId] : undefined
//   return getContract(address, TickLensABI) as TickLens | null
// }
